module.exports = __webpack_public_path__ + "media/images/twitter-fb2be14542beebc02c2c48d4161f1f42.svg";